
import Vue from 'vue';
import { SNACKBAR_STATUS } from '@/constants/constants';
import { SnackbarItem } from '@/store';

const DEFAULT_TIMEOUT = 5000;
const ERROR_TIMEOUT = 30000;

export default Vue.extend({
	name: 'GlobalSnackbarItem',
	props: {
		item: {
			type: Object as () => SnackbarItem,
			required: true,
		},
	},
	data () {
		return {
			timer: null as ReturnType<typeof setTimeout> | null,
			// Milliseconds left before auto-dismiss; decremented across hover pauses.
			remaining: 0 as number,
			startedAt: 0 as number,
		};
	},
	computed: {
		isError (): boolean {
			return this.item.status === SNACKBAR_STATUS.ERROR;
		},
		isWarning (): boolean {
			return this.item.status === SNACKBAR_STATUS.WARN;
		},
		timeoutTime (): number {
			return this.item.timeout || (this.isError && ERROR_TIMEOUT) || DEFAULT_TIMEOUT;
		},
		contentClass (): string {
			switch (this.item.status) {
				case SNACKBAR_STATUS.SUCCESS:
				case SNACKBAR_STATUS.ERROR:
				case SNACKBAR_STATUS.INFO:
				case SNACKBAR_STATUS.WARN:
				case SNACKBAR_STATUS.ACCENT:
					return 'white--text';
				default:
					return 'success';
			}
		},
		color (): string {
			switch (this.item.status) {
				case SNACKBAR_STATUS.SUCCESS:
					return 'success';
				case SNACKBAR_STATUS.ERROR:
					return 'error';
				case SNACKBAR_STATUS.INFO:
					return 'primary';
				case SNACKBAR_STATUS.WARN:
					return 'warning';
				case SNACKBAR_STATUS.ACCENT:
					return 'accent';
				default:
					return 'success';
			}
		},
	},
	mounted () {
		this.remaining = this.timeoutTime;
		this.start();
	},
	beforeDestroy () {
		this.clearTimer();
	},
	methods: {
		start () {
			this.clearTimer();
			this.startedAt = Date.now();
			this.timer = setTimeout(this.close, this.remaining);
		},
		pause () {
			if (!this.timer) return;
			this.clearTimer();
			this.remaining -= Date.now() - this.startedAt;
		},
		resume () {
			if (this.timer || this.remaining <= 0) return;
			this.start();
		},
		clearTimer () {
			if (this.timer) {
				clearTimeout(this.timer);
				this.timer = null;
			}
		},
		close () {
			this.clearTimer();
			this.$emit('dismiss', this.item.id);
		},
	},
});
